import { getApiBase } from '@papan/api-client'

/**
 * #809 — end a share VISIT server-side: the share view's own revoke. Sent from the share view (the frontend Origin), it
 * ends every session of the visit, not only this token, and the visits this browser has bound (#961). The ONE call both
 * leaves use: the share view's Log out, and a drive account end on the share view (#1316 review round 2, H2b — the old
 * account's visit must not stay live one Back away, since #989 binds a visit to the browser, not to the account).
 *
 * Raw (#1316): it is sent AFTER the visit ended client-side (`endSession`) — it is what ends it on the server, so a
 * session-bound fetch would drop it. Never throws. `keepalive` lets it complete while the page unloads.
 */
export async function revokeShareVisit(sessionId: string, opts: { keepalive?: boolean } = {}): Promise<void> {
  try {
    await fetch(`${getApiBase()}/api/share-links/session/${encodeURIComponent(sessionId)}/revoke`, {
      method: 'POST',
      credentials: 'include',
      ...(opts.keepalive ? { keepalive: true } : {}),
    })
  } catch { /* best-effort — the caller leaves either way */ }
}
